import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  Divider,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

//import SuiInput from "components/SuiInput";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

const formatCurrency = (value) => {
  //alert("value: " + JSON.stringify(value));
  //const number = value.replace(/\D/g, "");
  const number = value ? value.replace(/\D/g, "") : "0";
  //alert("number: " + JSON.stringify(number));
  const numberValue = Number(number);
  const formatter = new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return {
    formatted: formatter.format(number || 0).replace(/\s/g, ""),
    value: numberValue,
  };
};

//eslint-disable-next-line no-unused-vars
function CardDeudas({ proceso, deudas }) {
  const deudasFormateadas = deudas.map((deuda) => {
    const { formatted: capiFormatted, value: capiValue } = formatCurrency(
      String(deuda.capital || 0)
    );
    const { formatted: inteFormatted, value: inteValue } = formatCurrency(
      String(deuda.intereses || 0)
    );
    const { formatted, value } = formatCurrency(String(deuda.capital_conciliado || 0));
    return {
      ...deuda,
      capital: capiValue,
      capital_formatted: capiFormatted,
      intereses: inteValue,
      intereses_formatted: inteFormatted,
      capital_conciliado: value,
      capital_conciliado_formatted: formatted,
    };
  });

  // Agrupar las deudas por clase de deuda
  const deudasPorClase = deudasFormateadas.reduce((grupo, deuda) => {
    const clase = deuda.str_clase_deuda.nombre;
    if (!grupo[clase]) {
      grupo[clase] = [];
    }
    grupo[clase].push(deuda);
    return grupo;
  }, {});
  const totalCapital = deudas.reduce((total, deuda) => total + Number(deuda.capital || 0), 0);
  //const totalIntereses = deudas.reduce((total, deuda) => total + Number(deuda.intereses || 0), 0);
  //const totalDeuda = totalCapital + totalIntereses;

  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        padding: 2,
      }}
    >
      {/* Total de deudas */}
      <SuiBox p={1.5} display="flex" flexDirection="column" height="100%">
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={6}>
            <SuiTypography variant="h5" fontWeight="bold">
              Total Acreencias{"  "}
              <SuiTypography component="span">$ {totalCapital.toLocaleString()}</SuiTypography>
            </SuiTypography>
            <Divider sx={{ my: 0.25 }} />
          </Grid>
          <Grid size={6}></Grid>
        </Grid>
      </SuiBox>

      {/* Deudas agrupadas por clase */}
      <SuiBox p={1.5} display="flex" flexDirection="column">
        {Object.keys(deudasPorClase).length > 0 ? (
          Object.keys(deudasPorClase).map((clase) => (
            <SuiBox key={clase} mb={3}>
              <SuiTypography variant="h6" fontWeight="bold" color="primary">
                {clase}
              </SuiTypography>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}
                    >
                      Acreedor
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}
                    >
                      Etiqueta
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}
                    >
                      Capital Deuda
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}
                    >
                      Capital Conciliado
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}
                    >
                      Intereses
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold", whiteSpace: "nowrap", padding: "4px 8px" }}
                    >
                      Rango Mora
                    </TableCell>
                  </TableRow>
                  <TableBody>
                    {deudasPorClase[clase].map((deuda) => (
                      <TableRow key={deuda.id}>
                        <TableCell sx={{ padding: "4px 8px" }}>
                          {deuda.str_acreedor.nombre}
                        </TableCell>
                        <TableCell sx={{ padding: "4px 8px" }}>{deuda.etiqueta}</TableCell>
                        <TableCell sx={{ padding: "4px 8px" }}>{deuda.capital_formatted}</TableCell>
                        <TableCell sx={{ padding: "4px 8px" }}>
                          {deuda.capital_conciliado_formatted}
                        </TableCell>
                        <TableCell sx={{ padding: "4px 8px" }}>
                          {deuda.intereses_formatted}
                        </TableCell>
                        <TableCell sx={{ padding: "4px 8px" }}>{deuda.rango_mora}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </SuiBox>
          ))
        ) : (
          <Typography variant="body1" color="textSecondary">
            No hay acreencias registradas para este proceso.
          </Typography>
        )}
      </SuiBox>
    </Card>
  );
}

CardDeudas.propTypes = {
  proceso: PropTypes.object.isRequired,
  deudas: PropTypes.array.isRequired,
};

export default CardDeudas;
